<app-loading-spinner *ngIf="!(classAssessmentsLoaded && assessmentDefinitionsLoaded); else table"></app-loading-spinner>
<ng-template #table>
    <div class="row header-background mx-0">
        <h1 class="header-title">Assessments Summary</h1>
    </div>

    <div class="row mx-0 my-3">
        <select class="form-control" style="width: fit-content" [ngModel]="currentAssessmentCategory.CategoryName"
            (ngModelChange)="selectAssessmentCategory($event)">
            <option *ngFor="let category of assessmentCategories" [ngValue]="category.CategoryName">
                {{ category.CategoryName }}
            </option>
        </select>
    </div>

    <div *ngIf="!assessments || assessments.length === 0" class="mt-5">
        <h2 class="font-italic">No assessments in this category</h2>
    </div>

    <div *ngIf="assessments && assessments.length > 0" [class.scrollTable]="assessments && assessments.length > 8"
        #assessmentsTable>
        <table class="table">
            <thead>
                <th>
                    <app-sort-toggle columnName="AssessmentName" (orderChange)="updateSort($event)">
                        Assessment Name
                    </app-sort-toggle>
                </th>
                <th>
                    <app-sort-toggle columnName="NumPassed" (orderChange)="updateSort($event)">
                        Passed
                    </app-sort-toggle>
                </th>
                <th>
                    <app-sort-toggle columnName="NumAttempted" (orderChange)="updateSort($event)">
                        Attempted
                    </app-sort-toggle>
                </th>
                <th>
                    <app-sort-toggle columnName="NumNotTaken" (orderChange)="updateSort($event)">
                        Not Taken
                    </app-sort-toggle>
                </th>
                <th></th>
                <th></th>
            </thead>
            <tbody>
                <tr *ngFor="let assessment of assessments; index as i">
                    <!-- (click)="goToAssignmentDetails($event, assignment)"> -->
                    <td>{{ assessment.Title }}</td>
                    <td>{{ getNumPassed(assessment.ID) }}</td>
                    <td>{{ getNumAttempted(assessment.ID) }}</td>
                    <td>{{ getNumNotTaken(assessment.ID) }}</td>
                    <td>
                        <div class="d-flex justify-content-end">
                            <div class="btn btn-secondary" (click)="showAssessmentDetailsModal(assessment.ID)">View
                                Report
                            </div>
                        </div>
                    </td>
                    <td>
                        <div class="d-flex justify-content-end">
                            <div class="btn btn-primary px-4" (click)="showAssessmentRequestModal(assessment.ID)">
                                Assign
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>

    <app-request-assessment-modal #requestAssessment (dataRefresh)="refreshClassAssessmentsData($event)"
        [assessment]="selectedAssessment" [studentAssessmentDetails]="selectedAssessmentResults" [students]="students">
    </app-request-assessment-modal>

    <app-class-assessment-details-modal #assessmentDetails (dataRefresh)="refreshClassAssessmentsData($event)"
        (openRequestModal)="showAssessmentRequestModal($event)" [assessment]="selectedAssessment"
        [studentAssessmentDetails]="selectedAssessmentResults"
        [className]="className"></app-class-assessment-details-modal>
</ng-template>